import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NbDialogService } from "@nebular/theme";
import { NotificationsService } from "angular2-notifications";
import { NgxSpinnerService } from "ngx-spinner";
import { EImportacaoType } from "../../../../shared/importacao-lote/components/table/EImportacaoType";
import { IEnderecoDetalhes } from "../../../../shared/importacao-lote/dto/IEnderecoDetalhes";
import { ILoteDetalhes } from "../../../../shared/importacao-lote/dto/ILoteDetalhes";
import { abrirModalConfirmarCadastro } from "../../../../shared/importacao-lote/utils/abrir-modal-confirmar-cadastro";
import cancelarImportacaoLote from "../../../../shared/importacao-lote/utils/cancelar-importacao";
import { HttpService } from "../../../../shared/services/http/http-client.service";
import { getProductDescription } from "../../../importacao-lote/utils/get-product";

@Component({
  selector: "ngx-validar-pagamento-cartao",
  templateUrl: "./validar-pagamento-cartao.component.html",
  styleUrls: ["./validar-pagamento-cartao.component.scss"],
})
export class ValidarPagamentoCartaoComponent implements OnInit {
  public customLogin = null;
  public loteId: number = null;
  public breadcrumbPath: { label: string; link?: string }[];
  public loteDetalhes: ILoteDetalhes = null;
  public enderecoDetalhes: IEnderecoDetalhes = null;

  constructor(
    private http: HttpService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private dialogService: NbDialogService,
    private notifications: NotificationsService
  ) {}

  ngOnInit() {
    this.spinnerService.show();
    let resCustom = localStorage.getItem("bway-customLogin");
    this.customLogin = JSON.parse(resCustom);

    this.activatedRoute.queryParamMap.subscribe((params: any) => {
      this.loteId = params.params.loteId;
    });

    this.breadcrumbPath = [
      { label: "Lote ID " + this.loteId },
      {
        label: "Importação",
        link: `/pages/gestao-funcionarios/importar-arquivo?loteId=${this.loteId}`,
      },
      {
        label: "Revisar",
        link: `/pages/gestao-funcionarios/validar-importacao?loteId=${this.loteId}`,
      },
      {
        label: "Cartão",
      },
    ];

    this.getDados();
    this.spinnerService.hide();
  }

  getDados() {
    // detalhes do lote
    this.http.doGet(
      `/importacao-funcionario/${this.loteId}/detalhes-lote-funcionario`,
      "",
      (response: ILoteDetalhes) => {
        this.loteDetalhes = response;

        // tarifas
        this.http.doGet(
          `/importacao-funcionario/tarifa-emissao-cartao`,
          "",
          (response) => {
            if (response.taxaEmissao) {
              this.loteDetalhes.valorUnidade = response.taxaEmissao;
            }
          }
        );
      }
    );

    // endereço de entrega
    this.http.doGet(
      `/importacao-funcionario/endereco-lote`,
      "",
      (response: IEnderecoDetalhes) => {
        this.enderecoDetalhes = response;
      }
    );
  }

  getTotalPedido() {
    if (!this.loteDetalhes) return 0;

    return (
      (this.loteDetalhes.valorUnidade || 0) *
      (this.loteDetalhes.qtdCartoes || 0)
    );
  }

  getTitleAcao() {
    return this.getTotalPedido() > 0 ? "CONTINUAR" : "FINALIZAR";
  }

  openConfirmModal() {
    abrirModalConfirmarCadastro(
      this.dialogService,
      {
        produto: getProductDescription(),
        emitirCartao: "SIM",
        loteDetalhes: this.loteDetalhes,
        textButtonConfirm: this.getTitleAcao(),
      },
      () => {
        this.spinnerService.show();
        this.http.doPost(
          `/importacao-funcionario/${this.loteId}/processar-pagamento`,
          {
            valorSaldoGlobal: Number(0),
            valorSaldoConta: Number(0),
            valorSaldoRecebiveis: Number(0),
            valorPrimeiraVia: Number(this.loteDetalhes.valorUnidade || 0),
          },
          (_response: any) => {
            this.spinnerService.hide();
            this.router.navigate(["/pages/gestao-funcionarios/importacao-finalizada"], {
              relativeTo: this.activatedRoute,
              queryParams: { loteId: this.loteId },
            });
          },
          (_error: any) => {
            this.spinnerService.hide();
            this.notifications.error(
              "Ocorreu um erro ao finalizar: " + _error.toString()
            );
          }
        );
      },
      (_error) => {
        this.spinnerService.hide();
      }
    );
  }

  onContinue() {
    if (this.getTotalPedido() > 0) {
      this.router.navigate([`/pages/gestao-funcionarios/distribuicao-saldo`], {
        relativeTo: this.activatedRoute,
        queryParams: { loteId: this.loteId },
      });
    } else {
      this.openConfirmModal();
    }
  }

  onCancel() {
    cancelarImportacaoLote(
      this.dialogService,
      this.spinnerService,
      this.notifications,
      this.router,
      this.http,
      this.loteDetalhes,
      EImportacaoType.FUNCIONARIO
    );
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getLoginLogo() {
    return this.customLogin && this.customLogin.headerMenu
      ? "data:image/png;base64," + this.customLogin.headerMenu
      : "./../images/";
  }
}
